import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function EnglishLettersAndNumbersOnly(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    const isValid = /^[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/g.test(control.value.replace(/<[^>]*>/g, ''));
    return isValid ? null : { englishLettersAndNumbersOnly: true };
  };
}

